export const initFileInput = async (selector) => {
    const firstInput = document.querySelector(selector);
    if (!firstInput) return;
    try {
        const module = await import('../forms/file-input');
        module.initFileInput(selector);
    } catch (error) {
        console.error("Failed to initialize File Input:", error);
    }
}